<template>
  <div class="mod-list">
    <a-table :columns="columns" :data-source="dataBySort" row-key="index" :locale="locale" :pagination="data.pagination" :loading="loading" @change="onChange">
      <a slot="couponNumber" slot-scope="text, record" @click.prevent="onShowDetail(record)">{{ text }}</a>
      <span slot="couponType" slot-scope="text">{{ text | couponType }}</span>
      <span slot="couponQuata" slot-scope="text">{{ text }}（含以上）</span>
      <span slot="couponStatus" slot-scope="text">{{ text | couponStatus }}</span>
      <router-link slot="orderNo" slot-scope="text, record" :to="goToOrderDetail(record)" target="_blank">{{ text }}</router-link>
      <span slot="useDate" slot-scope="text">{{ text | format }}</span>
    </a-table>
  </div>
</template>

<script>
import _ from 'lodash'

const columns = [
  {
    dataIndex: 'indexNew',
    title: '序号',
    scopedSlots: { customRender: 'indexNew' }
  },
  {
    dataIndex: 'couponNumber',
    title: '优惠券号',
    scopedSlots: { customRender: 'couponNumber' }
  },
  {
    dataIndex: 'couponType',
    title: '优惠券类型',
    scopedSlots: { customRender: 'couponType' }
  },
  {
    dataIndex: 'couponAmount',
    title: '面值'
  },
  {
    dataIndex: 'couponQuata',
    title: '产品使用限额',
    scopedSlots: { customRender: 'couponQuata' }
  },
  {
    dataIndex: 'validity',
    title: '优惠券有效期'
  },
  {
    dataIndex: 'couponStatus',
    title: '状态',
    scopedSlots: { customRender: 'couponStatus' }
  },
  {
    dataIndex: 'orderNo',
    title: '订单号',
    scopedSlots: { customRender: 'orderNo' }
  },
  {
    dataIndex: 'useDate',
    title: '使用日期',
    scopedSlots: { customRender: 'useDate' }
  }
]

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataBySort () {
      const list = _.orderBy(this.data.list, ({ useDate }) => useDate || '', ['desc'])
      list.forEach((element, index) => {
        element.indexNew = index + 1
      })
      return list
    }
  },
  data () {
    return {
      columns,
      locale: {
        emptyText: '暂无数据'
      }
    }
  },
  methods: {
    onChange (pagination) {
      this.$emit('change', pagination)
    },
    onShowDetail (record) {
      this.$emit('detail', record)
    },
    goToOrderDetail (record) {
      let detailUrl = ''
      if (record.couponType === 'TICKET') {
        if (String(record.orderNo).length === 20) {
          detailUrl = `/order/detail?orderId=${record.orderId}`
        } else {
          detailUrl = `/order/v2/detail?orderId=${record.orderId}`
        }
      } else {
        // TODO: 未区分随票还是单独辅营
        if (String(record.orderNo).length === 20) {
          detailUrl = `/ancillary/subDetail?subOrderNo=${record.orderNo}`
        } else {
          detailUrl = `/ancillary/v2/subDetail?subOrderNo=${record.orderNo}`
        }
      }
      return detailUrl
    }
  }
}
</script>
